import React from 'react'
import { Polar } from 'react-chartjs-2';

function BestClient({getDateFormat, statistics}) {
    let getLabels = (bestBuyer) => {
        let arr = [];
        bestBuyer.map((obj) => {
            arr.push(obj.phoneNum);
        });
        return arr;
    }
    let getCounters = (bestBuyer) => {
        let arr = [];
        bestBuyer.map((obj) => {
            arr.push(obj.counter);
        });
        return arr;
    }
    
    let getRandomColors = (bestBuyer) => {
        let arr = [];
        for (let i=0; i<bestBuyer.length; i++) {
            arr.push("#"+((1<<24)*Math.random()|0).toString(16));
        }
        return arr;
    }
    
    let getData = (bestBuyer) => {
        return {
            labels: getLabels(bestBuyer),
            datasets: [
                {
                    label: 'Amount of purchases',
                    data: getCounters(bestBuyer),
                    backgroundColor: getRandomColors(bestBuyer)
                }
            ]
        }
    }

if (window.location.href.includes('/en')) {
    return (
        <div className="chartText">
            <div style={{textAlign: 'center', marginBottom: '30px'}}> (Showing the number of purchases by phone number)</div>

            {statistics.map((client, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(client.timestamp)} - Now</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(client.timestamp)}</div>}
                <div className="containerBar">
                    <Polar
                    data={getData(client.bestBuyer)}                       
                    options={{ 
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>  
    )
}

// Else render it in English
    return (
        <div className="chartText">
            <div style={{textAlign: 'center', marginBottom: '30px'}}> (מראה סכום רכישות ע"פ מספר פלאפון)</div>

            {statistics.map((client, index) => 
                <React.Fragment key={index}>

                {index==0 ? <div className="titleChart">{getDateFormat(client.timestamp)} - עכשיו</div>
                : <div className="titleChart">{getDateFormat(statistics[index-1].timestamp)} - {getDateFormat(client.timestamp)}</div>}
                <div className="containerBar">
                    <Polar
                    data={getData(client.bestBuyer)}                       
                    options={{ 
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false }}
                    />
                </div>

                </React.Fragment>
            )}
        </div>
    )
}

export default BestClient
